/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TestCaseVisibility } from './TestCaseVisibility';
import {
    TestCaseVisibilityFromJSON,
    TestCaseVisibilityFromJSONTyped,
    TestCaseVisibilityToJSON,
    TestCaseVisibilityToJSONTyped,
} from './TestCaseVisibility';

/**
 * The fields an edit may change. The problem, the status and the official output belong to
 * the server (preparation); a request that sends them changes nothing (#215).
 * @export
 * @interface TestCaseUpdate
 */
export interface TestCaseUpdate {
    /**
     * 
     * @type {string}
     * @memberof TestCaseUpdate
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TestCaseUpdate
     */
    driver_code: string;
    /**
     * 
     * @type {number}
     * @memberof TestCaseUpdate
     */
    points: number;
    /**
     * 
     * @type {TestCaseVisibility}
     * @memberof TestCaseUpdate
     */
    visibility: TestCaseVisibility;
}



/**
 * Check if a given object implements the TestCaseUpdate interface.
 */
export function instanceOfTestCaseUpdate(value: object): value is TestCaseUpdate {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('driver_code' in value) || value['driver_code'] === undefined) return false;
    if (!('points' in value) || value['points'] === undefined) return false;
    if (!('visibility' in value) || value['visibility'] === undefined) return false;
    return true;
}

export function TestCaseUpdateFromJSON(json: any): TestCaseUpdate {
    return TestCaseUpdateFromJSONTyped(json, false);
}

export function TestCaseUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): TestCaseUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'driver_code': json['driver_code'],
        'points': json['points'],
        'visibility': TestCaseVisibilityFromJSON(json['visibility']),
    };
}

export function TestCaseUpdateToJSON(json: any): TestCaseUpdate {
    return TestCaseUpdateToJSONTyped(json, false);
}

export function TestCaseUpdateToJSONTyped(value?: TestCaseUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'driver_code': value['driver_code'],
        'points': value['points'],
        'visibility': TestCaseVisibilityToJSON(value['visibility']),
    };
}

